import { render } from "./PaginaInicial.vue?vue&type=template&id=bdcef11e&scoped=true"
import script from "./PaginaInicial.vue?vue&type=script&lang=js"
export * from "./PaginaInicial.vue?vue&type=script&lang=js"

import "./PaginaInicial.vue?vue&type=style&index=0&id=bdcef11e&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdcef11e"]])

export default __exports__